/**
 * Owner: Haselton Baker Risk Group, LLC
 * Product: SP3 - SP3-Risk-Model-UI
 * Date: 12/21/20
 * Copyright All Rights Reserved
 */

const calculateUserRequestPutBody = (values) => {
  const {
    active, firstName, lastName, email, orgId, isAdmin,
  } = values;

  const permissions = isAdmin !== undefined ? { isAdmin } : {};

  return {
    active: !!active,
    firstName,
    lastName,
    email,
    orgId,
    permissions,
  };
};

export default calculateUserRequestPutBody;



// WEBPACK FOOTER //
// ./js/support/calculateUserRequestPutBody.js